import React, { Component } from "react";
import { imageURl } from "../../libs/env";
import { Row, Col } from "reactstrap";

import AudioAnalyser from "./AudioAnalyser";

class AudioTest extends Component {
  constructor(props) {
    super(props);
    this.state = { audio: null };
    this.toggleMicrophone = this.toggleMicrophone.bind(this);
  }

  async componentDidMount() {
    try {
      await this.getMicrophone();
  
    } catch (error) {
      console.error("Microphone access denied:", error);
      this.setState({ audio: null });
    }
  }

  async getMicrophone() {
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
    this.setState({ audio });
  }

  stopMicrophone() {
    this.state.audio.getTracks().forEach((track) => track.stop());
    this.setState({ audio: null });
  }

  toggleMicrophone() {
    if (this.state.audio) {
      this.stopMicrophone();
    } else {
      this.getMicrophone();
    }
  }

  render() {
    return (
      <Row className="p-4 py-2 f-13 align-items-center">
        <Col md={4} className="sfw-700">
          Click the button and say a few words to test your microphone
        </Col>
        <Col>
          <div
            className="controls col-sm-6 col-md-2 text-start"
            onClick={this.toggleMicrophone}
          >
            {!this.state.audio ? (
              <svg
                width="43"
                height="43"
                viewBox="0 0 43 43"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="21.5" cy="21.5" r="21.5" fill="#F52F37" />
                <rect
                  x="16.5391"
                  y="6.61719"
                  width="9.92308"
                  height="18.1923"
                  rx="4.96154"
                  stroke="white"
                  stroke-width="3.30769"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.92428 19.8469C9.92428 22.9173 11.144 25.8619 13.3151 28.033C15.4862 30.2041 18.4308 31.4238 21.5012 31.4238C24.5716 31.4238 27.5162 30.2041 29.6873 28.033C31.8584 25.8619 33.0781 22.9173 33.0781 19.8469"
                  stroke="white"
                  stroke-width="3.30769"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21.5 36.3839V33.0762"
                  stroke="white"
                  stroke-width="3.30769"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <img
                src={`${imageURl}/stop_mic.png`}
                width="43px"
                alt="Pause mic img"
              />
            )}
          </div>
        </Col>
        <Col sm={6} md={6}>
          {this.state.audio ? (
            <AudioAnalyser audio={this.state.audio} width={168} height={60} modalTest={true} />
          ) : null}
        </Col>
      </Row>
    );
  }
}

export default AudioTest;
